import { AxiosError } from 'axios';

import {
  DOCUMENT_AUDIT_TRAIL__DOWNLOAD_FAILURE,
  DOCUMENT_AUDIT_TRAIL__DOWNLOAD_REQUEST,
  DOCUMENT_AUDIT_TRAIL__DOWNLOAD_SUCCESS,
  DOCUMENT_AUDIT_TRAIL__FETCH_FAILURE,
  DOCUMENT_AUDIT_TRAIL__FETCH_REQUEST,
  DOCUMENT_AUDIT_TRAIL__FETCH_SUCCESS,
} from '@app/store/actionTypes';

export function downloadAuditTrail() {
  return {
    type: DOCUMENT_AUDIT_TRAIL__DOWNLOAD_REQUEST,
  };
}
export function downloadAuditTrailSuccess() {
  return {
    type: DOCUMENT_AUDIT_TRAIL__DOWNLOAD_SUCCESS,
  };
}
export function downloadAuditTrailFailure(error: AxiosError) {
  return {
    type: DOCUMENT_AUDIT_TRAIL__DOWNLOAD_FAILURE,
    payload: error,
    error: true,
  };
}

export function fetchAuditTrail(payload: { documentId: string }) {
  return {
    type: DOCUMENT_AUDIT_TRAIL__FETCH_REQUEST,
    payload,
  };
}
export function fetchAuditTrailSuccess(payload: { url: string }) {
  return {
    type: DOCUMENT_AUDIT_TRAIL__FETCH_SUCCESS,
    payload,
  };
}
export function fetchAuditTrailFailure(error: AxiosError) {
  return {
    type: DOCUMENT_AUDIT_TRAIL__FETCH_FAILURE,
    payload: error,
    error: true,
  };
}

export type DocumentAuditTrailAction =
  | ReturnType<typeof downloadAuditTrail>
  | ReturnType<typeof downloadAuditTrailSuccess>
  | ReturnType<typeof downloadAuditTrailFailure>
  | ReturnType<typeof fetchAuditTrail>
  | ReturnType<typeof fetchAuditTrailSuccess>
  | ReturnType<typeof fetchAuditTrailFailure>;
